import { useEffect, useState } from "react";
import { readUtm } from "./WhatsAppButton";

const BOT_USERNAME = "findrates_bot";

function sanitizeForTelegram(raw: string): string {
  return raw
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, "_")
    .slice(0, 55);
}

function detectStartParam(): string {
  const utm = readUtm();
  const src = (utm.utm_source || "").toLowerCase();
  if (src) return `src_${sanitizeForTelegram(src)}`;
  if (utm.fbclid) return "src_facebook_click";
  if (utm.gclid) return "src_google_click";
  return "site_direct";
}

function buildTelegramLink(): { param: string; url: string } {
  const param = detectStartParam();
  const url = `https://t.me/${BOT_USERNAME}?start=${param}`;
  return { param, url };
}

/** Public helper: Telegram deep link with a source-aware start parameter. */
export function buildTelegramUrl(): string {
  if (typeof window === "undefined") return `https://t.me/${BOT_USERNAME}`;
  return buildTelegramLink().url;
}

type TelegramButtonProps = {
  className?: string;
  label?: string;
};

export function TelegramButton({ className, label = "Open the Telegram bot" }: TelegramButtonProps) {
  const [href, setHref] = useState(`https://t.me/${BOT_USERNAME}`);

  useEffect(() => {
    const { url } = buildTelegramLink();
    setHref(url);
  }, []);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={
        className ??
        "h-11 inline-flex items-center px-5 rounded-full bg-[#229ED9] text-white text-sm font-medium hover:bg-[#1b87ba] transition-colors no-underline"
      }
    >
      <span>{label}</span>
    </a>
  );
}
